(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/client-events-handler/assets/javascripts/notifications-handler.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/client-events-handler/assets/javascripts/notifications-handler.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
const _dateFns = dateFns,
  subMinutes = _dateFns.subMinutes;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const _svs$components$oddse = svs.components.oddset.selfserviceIntegration,
  addToCart = _svs$components$oddse.addToCart,
  parseWager = _svs$components$oddse.parseWager;
const OddsmindConstants = svs.oddset_kambi.components.common.constants.OddsmindConstants;
const updateBalance = svs.oddset_kambi.components.common.utils.updateBalance;
const _svs$oddset_kambi$com = svs.oddset_kambi.components.clientEventsHandler.constants,
  NotificationEvent = _svs$oddset_kambi$com.NotificationEvent,
  DataLayerEvent = _svs$oddset_kambi$com.DataLayerEvent;
const _svs$oddset_kambi$com2 = svs.oddset_kambi.components.analytics,
  _svs$oddset_kambi$com3 = _svs$oddset_kambi$com2.betSlipEvents,
  trackAddOutcomeToBetslip = _svs$oddset_kambi$com3.trackAddOutcomeToBetslip,
  trackClearBetslip = _svs$oddset_kambi$com3.trackClearBetslip,
  trackBetReceiptKeepCouponSelection = _svs$oddset_kambi$com3.trackBetReceiptKeepCouponSelection,
  _svs$oddset_kambi$com4 = _svs$oddset_kambi$com2.transactionEvents,
  trackPayment = _svs$oddset_kambi$com4.trackPayment,
  trackCashout = _svs$oddset_kambi$com4.trackCashout,
  _svs$oddset_kambi$com5 = _svs$oddset_kambi$com2.miscEvents,
  trackSandwichFilterClicked = _svs$oddset_kambi$com5.trackSandwichFilterClicked,
  trackHighlightPromoClick = _svs$oddset_kambi$com5.trackHighlightPromoClick,
  trackLiveStreamInteraction = _svs$oddset_kambi$com5.trackLiveStreamInteraction,
  trackHighlightPromoView = _svs$oddset_kambi$com5.trackHighlightPromoView,
  trackSearchResult = _svs$oddset_kambi$com5.trackSearchResult;
const handleCustomizedFeedback = svs.oddset_kambi.components.customizedFeedbackHandler.handleCustomizedFeedback;
const _svs$oddset_kambi$com6 = svs.oddset_kambi.components.wapiIntegration,
  clearBetslip = _svs$oddset_kambi$com6.clearBetslip,
  hideSportsbook = _svs$oddset_kambi$com6.hideSportsbook,
  showSportsbook = _svs$oddset_kambi$com6.showSportsbook;
const logger = svs.core.log.getLogger('oddset_kambi:components:clientEventsHandle:notificationsHandler');
const showGrasrotenDialog = svs.components.oddset.common.grasroten;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const getOddsmindOffset = svs.oddset_kambi.components.common.utils.getOddsmindOffset;

const getDateWithOffset = dateString => {
  const date = new Date(dateString);
  const localOffset = new Date().getTimezoneOffset();
  return subMinutes(date, localOffset);
};
const resizeOddsmindBetslipAdjustment = betslipStatus => {
  if (!isLoggedIn || !svs.oddsmind.isSmallScreen || !betslipStatus) {
    return;
  }
  const isSmallScreen = svs.oddsmind.isSmallScreen;
  const offset = getOddsmindOffset({
    isLoggedIn,
    isSmallScreen,
    betslipStatus
  });
  const chat = document.querySelector('oddsmind-chat');
  if (chat) {
    chat.setAttribute('bottom-offset', offset.bottom);
  }
};

const handleDataLayerEvent = (eventData, _ref) => {
  let refreshPendingBets = _ref.refreshPendingBets;
  switch (eventData.event) {
    case DataLayerEvent.ADD_TO_BETSLIP:
      trackAddOutcomeToBetslip(eventData);
      break;
    case DataLayerEvent.CLEAR_BETSLIP:
      trackClearBetslip(eventData);
      break;
    case DataLayerEvent.PAYMENT_COMPLETE:
      if (isLoggedIn) {
        trackPayment(eventData);
        updateBalance();
        refreshPendingBets();
      }
      break;
    case DataLayerEvent.RECIEPT_CLOSED:
      if (!isSelfService) {
        trackBetReceiptKeepCouponSelection(eventData);
        showGrasrotenDialog();
      }
      break;
    case DataLayerEvent.SANDWICH_FILTER_CLICK:
      trackSandwichFilterClicked(eventData);
      break;
    case DataLayerEvent.CASHOUT:
      if (isLoggedIn) {
        var _eventData$ecommerce;
        if ((_eventData$ecommerce = eventData.ecommerce) !== null && _eventData$ecommerce !== void 0 && _eventData$ecommerce.items) {
          trackCashout(eventData);
          updateBalance();
        }
        refreshPendingBets();
      }
      break;
    case DataLayerEvent.HIGHLIGHT_CARD_CLICK:
      trackHighlightPromoClick(eventData);
      break;
    case DataLayerEvent.HIGHLIGHT_CARD_VIEW:
      trackHighlightPromoView(eventData);
      break;
    case DataLayerEvent.KAMBI_STREAM_PLAYER_INTERACTION:
      trackLiveStreamInteraction(eventData);
      break;
    case DataLayerEvent.KAMBI_SEARCH_RESULT:
      trackSearchResult(eventData.kambi.search.term);
      break;
    case DataLayerEvent.BETSLIP_STATUS:
      if (eventData.kambi.betslip.quantity >= 1) {
        resizeOddsmindBetslipAdjustment(OddsmindConstants.BETSLIP_VISIBLE);
      } else {
        resizeOddsmindBetslipAdjustment(OddsmindConstants.BETSLIP_HIDDEN);
      }
      break;
    default:
      break;
  }
};

const getNotificationsHandler = _ref2 => {
  let setKambiMaintenance = _ref2.setKambiMaintenance,
    setActivePathname = _ref2.setActivePathname,
    refreshPendingBets = _ref2.refreshPendingBets,
    refreshPendingBetsThrottled = _ref2.refreshPendingBetsThrottled;
  return _ref3 => {
    let name = _ref3.name,
      data = _ref3.data,
      state = _ref3.state;
    switch (name) {
      case NotificationEvent.BET_SELECTION_READY:
        {
          if (isSelfService) {
            addToCart(parseWager(data));
            clearBetslip();
          }
          break;
        }
      case NotificationEvent.DATA_LAYER_PUSHED:
        handleDataLayerEvent(data, {
          refreshPendingBets
        });
        break;
      case NotificationEvent.MAINTENANCE:
        {
          if (state.isMaintenance) {
            const startDate = getDateWithOffset(state.startingAt);
            const endDate = getDateWithOffset(state.endingAt);
            setKambiMaintenance({
              isMaintenance: state.isMaintenance,
              endingAt: endDate,
              startingAt: startDate
            });
            hideSportsbook();
            logger.info('The sportsbetting system is currently being upgraded, will be back at ', endDate);
          } else {
            setKambiMaintenance(null);
            showSportsbook();
          }
          break;
        }
      case NotificationEvent.CUSTOMIZED_FEEDBACK:
        {
          handleCustomizedFeedback(data);
          break;
        }
      case NotificationEvent.ROUTE_CHANGE:
        {
          refreshPendingBetsThrottled();
          if (data.currentRoute === 'home') {
            setActivePathname('/');
          } else {
            setActivePathname("/".concat(data.currentRoute));
          }
          break;
        }
      default:
        break;
    }
  };
};
setGlobal('svs.oddset_kambi.components.clientEventsHandler.getNotificationsHandler', getNotificationsHandler);

 })(window);